import Placeholder from '@cobliteam/ui/components/Placeholder';

const DropdownVehiclesPlaceholder = () => <Placeholder className='m-5' icon='cb-placeholder-car' text='Nenhum veículo encontrado.' />;

export default DropdownVehiclesPlaceholder;
